<ng-container *ngIf="(label$ | async) === 'general'">
    <div class="p-2 d-flex flex-column" *ngIf="profile">
        <div class="form-check p-2 ms-4">
            <input
                class="form-check-input"
                id="profileAndUsers"
                type="checkbox"
                [disabled]="profile.isLocked && authService.isUser"
                [(ngModel)]="servicePermissions[label].canManageProfilesAndUsers"
            />
            <label class="form-check-label" for="profileAndUsers" translate="company.profiles.permissions.canManageProfilesAndUsers"></label>
        </div>
        <div class="form-check p-2 ms-4">
            <input
                class="form-check-input"
                id="installPatients"
                type="checkbox"
                [disabled]="profile.isLocked && authService.isUser"
                [(ngModel)]="servicePermissions[label].canInstallPatients"
            />
            <label class="form-check-label" for="installPatients" translate="company.profiles.permissions.canInstallPatients"></label>
        </div>
        <div class="form-check p-2 ms-4" *ngIf="authService.isAdmin || isCommonLaw !== null">
            <input
                class="form-check-input"
                id="readBills"
                type="checkbox"
                [disabled]="profile.isLocked && authService.isUser"
                [(ngModel)]="servicePermissions[label].canOnlyReadBills"
                (change)="changeConditionalPermission($event, 'canOnlyReadBills')"
            />
            <label class="form-check-label" for="readBills" translate="company.profiles.permissions.canOnlyReadBills"></label>
        </div>
        <div class="form-check p-2 ms-4" *ngIf="authService.isAdmin || isCommonLaw !== null">
            <input
                class="form-check-input"
                id="bill"
                type="checkbox"
                [disabled]="profile.isLocked && authService.isUser"
                [(ngModel)]="servicePermissions[label].canBill"
                (change)="changeConditionalPermission($event, 'canBill')"
            />
            <label class="form-check-label" for="bill" translate="company.profiles.permissions.canBill"></label>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="(label$ | async) !== 'general'">
    <div class="p-2 d-flex flex-column">
        <div class="form-check p-2 ms-3">
            <input
                class="form-check-input"
                id="canActivateView"
                type="checkbox"
                [disabled]="profile.isLocked && authService.isUser"
                [(ngModel)]="servicePermissions[label].canActivateView"
                (change)="disablePermissions($event)"
            />
            <label class="form-check-label" for="canActivateView" translate="company.profiles.permissions.canActivateView"></label>
        </div>
        <ng-container *ngIf="profile.type === 'medical'">
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canBeReferent"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canBeReferent"
                    (change)="activateReferentConditionalPermissions()"
                />
                <label class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}" for="canBeReferent" translate="company.profiles.permissions.canBeReferent"></label>
            </div>
            <p class="subtitle" translate="company.profiles.permissions.patientMap"></p>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canInclude"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canIncludePatient"
                    (change)="changeConditionalPermission($event, 'canIncludePatient')"
                />
                <label class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}" for="canInclude" translate="company.profiles.permissions.canIncludePatient"></label>
            </div>
            <div class="form-check subcheck" *ngIf="authService.isAdmin || isCommonLaw">
                <input
                    class="form-check-input"
                    id="canReInclude"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canReincludePatient"
                    (change)="changeConditionalPermission($event, 'canReincludePatient')"
                />
                <label class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}" for="canReInclude" translate="company.profiles.permissions.canReincludePatient"></label>
            </div>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canStop"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canStopPatient"
                    (change)="changeConditionalPermission($event, 'canStopPatient')"
                />
                <label class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}" for="canStop" translate="company.profiles.permissions.canStopPatient"></label>
            </div>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canReportEvent"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canReportEvent"
                    (change)="changeConditionalPermission($event, 'canReportEvent')"
                />
                <label class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}" for="canReportEvent" translate="company.profiles.permissions.canReportEvent"></label>
            </div>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canGeneratePrescriptionBioTherapeutic"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canGeneratePrescriptionBioTherapeutic"
                />
                <label
                    class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                    for="canGeneratePrescriptionBioTherapeutic"
                    translate="company.profiles.permissions.canGeneratePrescriptionBioTherapeutic"
                ></label>
            </div>
            <div class="form-check subcheck" *ngIf="authService.isAdmin || isCommonLaw">
                <input
                    class="form-check-input"
                    id="canGeneratePrescription"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canGeneratePrescription"
                    (change)="changeConditionalPermission($event, 'canGeneratePrescription')"
                />
                <label
                    class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                    for="canGeneratePrescription"
                    translate="company.profiles.permissions.canGeneratePrescription"
                ></label>
            </div>
            <p class="subtitle" translate="company.profiles.permissions.manageMedicalAlerts"></p>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canViewMedicalAlerts"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canViewMedicalAlerts"
                    (change)="changeConditionalPermission($event, 'canViewMedicalAlerts')"
                />
                <label
                    class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                    for="canViewMedicalAlerts"
                    translate="company.profiles.permissions.canViewMedicalAlerts"
                ></label>
            </div>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canManageMedicalAlerts"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canManageMedicalAlerts"
                    (change)="changeConditionalPermission($event, 'canManageMedicalAlerts')"
                />
                <label
                    class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                    for="canManageMedicalAlerts"
                    translate="company.profiles.permissions.canManageMedicalAlerts"
                ></label>
            </div>
        </ng-container>
        <ng-container *ngIf="!company.services?.[label]?.isTechnicalAlertManagedByNewcard">
            <p class="subtitle" translate="company.profiles.permissions.manageTechnicalAlerts"></p>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canManageTechnicalAlerts"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canManageTechnicalAlerts"
                />
                <label
                    class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                    for="canManageTechnicalAlerts"
                    translate="company.profiles.permissions.canManageTechnicalAlerts"
                ></label>
            </div>
        </ng-container>
        <p class="subtitle" translate="company.profiles.permissions.patientRecord"></p>
        <div class="form-check subcheck">
            <input
                class="form-check-input"
                id="canSendSMS"
                type="checkbox"
                [disabled]="isSubcheckDisabled"
                [(ngModel)]="servicePermissions[label].canSendSMS"
                (change)="changeConditionalPermission($event, 'canSendSMS')"
            />
            <label class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}" for="canSendSMS" translate="company.profiles.permissions.canSendSMS"></label>
        </div>
        <div class="form-check subcheck">
            <input
                class="form-check-input"
                id="canConsultDocuments"
                type="checkbox"
                [disabled]="isSubcheckDisabled"
                [(ngModel)]="servicePermissions[label].canConsultDocumentsAndPrescriptions"
                (change)="changeConditionalPermission($event, 'canConsultDocumentsAndPrescriptions')"
            />
            <label
                class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                for="canConsultDocuments"
                translate="company.profiles.permissions.canConsultDocumentsAndPrescriptions"
            ></label>
        </div>
        <div class="form-check subcheck">
            <input
                class="form-check-input"
                id="canImportDocs"
                type="checkbox"
                [disabled]="isSubcheckDisabled"
                [(ngModel)]="servicePermissions[label].canImportDocumentOnPatientRecord"
                (change)="changeConditionalPermission($event, 'canImportDocumentOnPatientRecord')"
            />
            <label
                class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                for="canImportDocs"
                translate="company.profiles.permissions.canImportDocumentOnPatientRecord"
            ></label>
        </div>
        <div class="form-check subcheck">
            <input
                class="form-check-input"
                id="canEditAdministrativeInfos"
                type="checkbox"
                [disabled]="isSubcheckDisabled"
                [(ngModel)]="servicePermissions[label].canEditAdministrativeInfos"
                (change)="changeConditionalPermission($event, 'canEditAdministrativeInfos')"
            />
            <label
                class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                for="canEditAdministrativeInfos"
                translate="company.profiles.permissions.canEditAdministrativeInfos"
            ></label>
        </div>
        <div class="form-check subcheck" *ngIf="profile.type === 'medical'">
            <input
                class="form-check-input"
                id="canEditMedicalInfos"
                type="checkbox"
                [disabled]="isSubcheckDisabled"
                [(ngModel)]="servicePermissions[label].canEditMedicalInfos"
                (change)="changeConditionalPermission($event, 'canEditMedicalInfos')"
            />
            <label
                class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                for="canEditMedicalInfos"
                translate="company.profiles.permissions.canEditMedicalInfos"
            ></label>
        </div>
        <div class="form-check subcheck" *ngIf="profile.type === 'medical'">
            <input
                class="form-check-input"
                id="canViewMedicalEventsAndComment"
                type="checkbox"
                [disabled]="isSubcheckDisabled"
                [(ngModel)]="servicePermissions[label].canViewMedicalEventsAndComment"
                (change)="changeConditionalPermission($event, 'canViewMedicalEventsAndComment')"
            />
            <label
                class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                for="canViewMedicalEventsAndComment"
                translate="company.profiles.permissions.canViewMedicalEventsAndComment"
            ></label>
        </div>
        <div class="form-check subcheck">
            <input
                class="form-check-input"
                id="canViewTechnicalEventsAndComment"
                type="checkbox"
                [disabled]="isSubcheckDisabled"
                [(ngModel)]="servicePermissions[label].canViewTechnicalEventsAndComment"
                (change)="changeConditionalPermission($event, 'canViewTechnicalEventsAndComment')"
            />
            <label
                class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                for="canViewTechnicalEventsAndComment"
                translate="company.profiles.permissions.canViewTechnicalEventsAndComment"
            ></label>
        </div>
        <ng-container *ngIf="profile.type === 'medical'">
            <p class="subtitle" translate="company.profiles.permissions.therapyCoaching"></p>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canViewTherapyCoaching"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canViewTherapyCoaching"
                    (change)="changeConditionalPermission($event, 'canViewTherapyCoaching')"
                />
                <label
                    class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                    for="canViewTherapyCoaching"
                    translate="company.profiles.permissions.canViewTherapyCoaching"
                ></label>
            </div>
            <div class="form-check subcheck">
                <input
                    class="form-check-input"
                    id="canAddTherapyCoaching"
                    type="checkbox"
                    [disabled]="isSubcheckDisabled"
                    [(ngModel)]="servicePermissions[label].canAddTherapyCoachingSession"
                    (change)="changeConditionalPermission($event, 'canAddTherapyCoachingSession')"
                />
                <label
                    class="form-check-label {{ isSubcheckDisabled ? 'disabled' : '' }}"
                    for="canAddTherapyCoaching"
                    translate="company.profiles.permissions.canAddTherapyCoachingSession"
                ></label>
            </div>
        </ng-container>
    </div>
</ng-container>
